const Container = ({ children }) => {
    return (
        <div style={{ height: "calc(100% - 97px)" }} className="px-8 py-6 overflow-y-scroll">
            {children}
        </div>
    );
};

export default Container;